import css from 'styled-jsx/css';

export default css`
    /*
    *  Boon Button Style
    */

    .BoonButton {
    }

    .onepx-up {
        margin-top: -1px;
    }

    .onepx-down {
        margin-bottom: -1px;
    }

    .onepx-left {
        margin-left: -1px;
    }

    .twopx-left {
        margin-left: -2px;
    }

    .onepx-right {
        margin-right: -1px;
    }

    .twopx-right {
        margin-right: -2px;
    }
`;
